import AnalyticsManager from './analyticsManager';
import AnalyticsInitializationListener from './analyticsInitializationListener';
import { events } from './events';

const analytics: AnalyticsManager = new AnalyticsManager();
const analyticsListener = new AnalyticsInitializationListener();

export { analytics, analyticsListener, events };
